import { ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { Storage, getDownloadURL, ref } from '@angular/fire/storage';
import { FormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/auth.service';
import { environment } from 'src/environments/environment';
import { MaterialModule } from '../../material.module';
import { AppConfirmService } from '../../services/app-confirm/app-confirm.service';
import { ToastService } from '../../services/toast/toast.service';

@Component({
  selector: 'app-user-edit',
  templateUrl: './user-edit.component.html',
  styleUrls: ['./user-edit.component.scss'],
  standalone: true,
  imports: [MaterialModule, FormsModule, TranslateModule],
})
export class UserEditComponent implements OnInit {
  query = '';
  searchResult = [];
  currentUser;
  newUserRole;
  userTypes = ['Admin', 'Writer', 'Reader'];
  loading = false;
  passwordShown = false;
  storage;
  constructor(
    private authService: AuthService,
    private toast: ToastService,
    private confirm: AppConfirmService,
    private changeDetectorRef: ChangeDetectorRef,
    private translate: TranslateService
  ) {
    this.storage = inject(Storage);
  }

  ngOnInit() {}

  getCurrentUserID() {
    return this.authService.userInfo()._id;
  }

  selectUser(user) {
    if (this.currentUser.hasOwnProperty('_id')) {
      if (user._id == this.currentUser._id) {
        this.currentUser = {};
        const userIndex = this.searchResult.findIndex((user) => user._id == this.currentUser._id);

        return;
      }
    }
    this.currentUser = user;
    this.newUserRole = this.currentUser.type;
  }

  deleteUser(userID) {
    this.confirm.confirm({ message: this.translate.instant('Confirm.DeleteUser') }).subscribe((confirm) => {
      if (confirm) {
        this.authService.deleteAccountLocal({ id: userID }).subscribe(
          (res) => {
            this.toast.snackbar.open(this.translate.instant('Snackbar.Done'), 'Ok', { duration: 2000 });
            this.performSearch();
          },
          (err) => {
            this.toast.snackbar.open(this.translate.instant('Snackbar.Error'), 'Ok', { duration: 2000 });
          }
        );
      }
    });
  }

  setRole() {
    this.loading = true;
    this.authService
      .setRole({
        userID: this.currentUser.id,
        role: this.newUserRole,
      })
      .subscribe(
        (res) => {
          this.performSearch();
          this.loading = false;
          this.toast.snackbar.open(this.translate.instant('Snackbar.NewRoleSuccess'), 'Ok', { duration: 2000 });
        },
        (err) => {
          this.toast.snackbar.open(this.translate.instant('Snackbar.NewRoleFail'), 'Ok', { duration: 2000 });
        }
      );
  }

  disableAccount() {
    this.confirm.confirm().subscribe((res) => {
      if (res) {
        this.authService.deleteUserAccount({ id: this.currentUser.id }).subscribe((res) => {
          this.performSearch();
          this.toast.snackbar.open(this.translate.instant('Snackbar.Done'), 'Ok', {
            duration: 2000,
          });
        });
      }
    });
  }

  enableAccount() {
    this.confirm.confirm().subscribe((res) => {
      if (res) {
        this.authService.enableUserAccount({ id: this.currentUser.id }).subscribe((res) => {
          this.performSearch();
          this.toast.snackbar.open(this.translate.instant('Snackbar.Done'), 'Ok', {
            duration: 2000,
          });
        });
      }
    });
  }
  getDownloadURL(url) {
    const reference = ref(this.storage, url);
    return getDownloadURL(reference);
  }

  performSearch() {
    this.loading = true;
    if (this.query.length > 3) {
      this.loading = false;
      this.currentUser = {};
      this.authService.searchUserSimple(this.query).subscribe((res) => {
        this.searchResult = res || [];
        this.searchResult = this.searchResult.map((element) => {
          element.photo = element.photo || 'assets/images/no_user.png';
          return element;
        });
        for (let i = 0; i < this.searchResult.length; i++) {
          const user = this.searchResult[i];
          if (user.photo != 'null' && user.photo) {
            const actualFileName = user.photo.split(`/${environment.profilePictureBucketName}/`)[1];
            this.getDownloadURL(`gs://${environment.profilePictureBucketName}/${actualFileName}`)
              .then((photoLink) => {
                this.searchResult[i].photo = photoLink;
              })
              .catch((err) => {
                console.error('error while getting profile photo link');
              });
          }
        }
        this.changeDetectorRef.markForCheck();
      });
    } else {
      this.searchResult = [];
    }
  }
}
